export function showLoadingIndicator() {
    const loadingOverlay = document.createElement("div");
    loadingOverlay.id = "loadingOverlay";
    const loadingProgressBar = document.createElement("div");
    loadingProgressBar.id = "loadingProgressBar";
    loadingOverlay.appendChild(loadingProgressBar);
    document.body.appendChild(loadingOverlay);
}

export function removeLoadingIndicator() {
    const loadingOverlay = document.body.querySelector("#loadingOverlay");
    loadingOverlay?.remove();
}
